import { proxy, useSnapshot } from "valtio"

const store = proxy({
  customer: null,
  tasks: [],
  open: false
})

export const openDialog = ({ customer, showCustomer = false }) => {
  store.open = true
  store.customer = customer
  store.showCustomer = showCustomer
}

export const closeDialog = () => {
  store.open = false
  store.tasks = []
  store.customer = null
}

export const setTasks = (tasks) => {
  store.tasks = tasks
}

export const useStore = () => {
  return useSnapshot(store)
}
